export default "__VITE_PUBLIC_ASSET__5e558732__"